<template>
  <!-- add face template Modal -->
  <div id="sick_leave" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-fullscreen" role="document">
      <div class="modal-content">
        <div class="modal-header header-colour pb-5">
          <h5 class="modal-title text-light">Sick Leave - {{ user.name }}</h5>
          <button type="button" class="btn-close" ref="Close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row ">
            <div class="text-end"> <a href="javascript:void(0);" class="btn add-btn" data-bs-toggle="modal"
                data-bs-target="#add_leave" @click="openAddLeave"><i class="fa-solid fa-plus"></i>Add Leave</a></div>

          </div>

          <div class="mt-5 border p-3">
            <div v-if="!requiresFollowup">
              <div class="d-flex">
                <h2>Is {{ user.name }} on a sick leave? </h2>
                <div class="btn btn-primary ms-5" @click="onSickLeave">Yes</div>
              </div>


            </div>
            <div v-else>
              <h3>{{ user.name }} is on a sick leave since {{ dateFormat(onSickLeaveData.start_date) }}</h3>
              <p>Next time they check-in for work, the system will prompt them to fill in the sick leave form</p>
            </div>

          </div>
          <div class="row mt-5">
            <div class="col-md-12">
              <!-- <div class="showentries mb-3 custom-select ">
            <div class="d-flex align-items-center gap-2"><span>Show</span>
              <select style="outline: none" v-model="perPage" @change="userLeaves">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              <span>entries</span>
            </div>
          </div> -->
              <div class="table-responsive" v-if="!loader">
                <a-table class="stripped table-hover" :columns="columns" :data-source="leaveData" :pagination="false">
                  <template #bodyCell="{ column, record }">
                    <template v-if="column.key === 'leave_master_category_id'">
                      <h6 class="table-avatar">

                        {{ getCategoriesName(record.leave_master_category_id) }}
                      </h6>
                    </template>
                    <template v-if="column.key === 'Status'">
                      <div class="text-center">
                        <div class="action-label">
                          <a class="btn btn-white btn-sm btn-rounded" href="javascript:void(0);">
                            <i :class="record.class"></i>
                            {{ record.status }}
                          </a>
                        </div>
                      </div>
                    </template>
                    <template v-if="column.key === 'Approvedby'">
                      <h2 class="table-avatar">
                        <!--                      <router-link to="/profile/employee-profile">-->
                        <!--                        <img-->
                        <!--                          :src="require(`@/assets/img/profiles/${record.Image}`)"-->
                        <!--                          alt="User Image"-->
                        <!--                      />-->
                        <!--                      </router-link>-->
                        <a href="javascript:;">{{ record.updated_by_user ? (record.updated_by_user.first_name + ' ' + record.updated_by_user.last_name) : (record.status_updated_by ? record.status_updated_by : '--') }}</a>
                      </h2>
                    </template>
                    <template v-else-if="column.key === 'status_updated_at'">
                      {{ record.status_updated_at ? formatDateTimeStandardWithTime(record.status_updated_at) : (record.updated_at ? formatDateTimeStandardWithTime(record.updated_at) : '--') }}
                    </template>
                    <template v-if="column.key === 'action' && showActionButton">
                      <div class="text-end">
                        <div class="dropdown dropdown-action">
                          <a href="javascript:;" class="action-icon dropdown-toggle" data-bs-toggle="dropdown"
                            aria-expanded="false"><i class="material-icons">more_vert</i></a>
                          <div class="dropdown-menu dropdown-menu-right">

                            <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal"
                              data-bs-target="#sick_leave_details_modal" @click="view(record, user.name)"><i
                                class="fa-solid fa-eye m-r-5"></i>View Details</a>

                          </div>
                        </div>
                      </div>
                    </template>
                  </template>
                </a-table>
              </div>
              <div class="d-flex justify-content-center text-center mt-5" v-else>
                <div class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /add face template Modal -->
  <sick-leave-details-modal ref="sickLeave"></sick-leave-details-modal>

</template>

<script>
import axios from "axios";
import { VUE_APP_API_BASE_URL } from "../../config";
import { formatMMNameYYYY, calcDays, statusIconClass, formatDateTimeStandardWithTime } from "@/utils/util-funcitons";
import dayjs from "dayjs";

const columns = [
  {
    title: "Leave Type",
    dataIndex: "type",
    key: "type",
    width: 80,
    sorter: {
      compare: (a, b) => {
        a = a.type.toLowerCase();
        b = b.type.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Category",
    dataIndex: "leave_master_category_id",
    key: "leave_master_category_id"
  },
  {
    title: "From",
    dataIndex: "start_date",
    sorter: {
      compare: (a, b) => {
        a = a.start_date.toLowerCase();
        b = b.start_date.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "To",
    dataIndex: "end_date",
    sorter: {
      compare: (a, b) => {
        a = a.end_date.toLowerCase();
        b = b.end_date.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "No of Days",
    dataIndex: "no_of_days",
    key: "NoOfDays",
    sorter: {
      compare: (a, b) => {
        a = a.no_of_days.toLowerCase();
        b = b.no_of_days.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Reason",
    dataIndex: "reason",
    ellipsis: true,
    sorter: {
      compare: (a, b) => {
        a = a.reason.toLowerCase();
        b = b.reason.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "Status",
    sorter: {
      compare: (a, b) => {
        a = a.status.toLowerCase();
        b = b.status.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Status Updated by",
    dataIndex: "status_updated_by",
    key: "Approvedby",
    sorter: {
      compare: (a, b) => {
        a = a.status_updated_by.toLowerCase();
        b = b.status_updated_by.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Status Updated at",
    dataIndex: "status_updated_at",
    key: "status_updated_at",
  },
  {
    title: "Action",
    sorter: true,
    key: "action",
    text: "end",
  },
];
export default {

  data() {
    return {
      columns,
      loader: false,
      template_image_path: "",
      id: "",
      user: [],
      leaveData: null,
      perPage: 10,
      annualLeaves: null,
      paidLeaves: null,
      unpaidLeaves: null,
      accessToken: [],
      showActionButton: true,
      masterCategoryIds: [],
      requiresFollowup: false,
      onSickLeaveData: []
    };
  },

  mounted() {

    this.getMasterCategories();
  },
  methods: {
    formatDateTimeStandardWithTime,
    dateFormat(date) {
      return formatMMNameYYYY(date);
    },
    openAddLeave() {
      const userId = this.user ? (this.user.id || this.user.user_id) : this.id;
      if (this.$refs.leaveAdmin && userId) {
        this.$refs.leaveAdmin.setEmployee(userId);
      }
    },
    updateValues(item) {
      this.id = item.id;
      this.user = item;
      if (this.$refs.leaveAdmin) {
        this.$refs.leaveAdmin.setEmployee(item.id || item.user_id);
      }
      this.userLeaves();
      this.checkForOnSickLeave();
    },

    async userLeaves() {
      this.loader = true;
      let headers = {
        "Access-Control-Allow-Headers": "*",
        "content-type": "application/json",
        "Accept": "/",
        "Authorization": "Bearer " + localStorage.getItem("accessToken"),
        "ngrok-skip-browser-warning": true
      };

      await axios.get(`${VUE_APP_API_BASE_URL}/leave/${this.id}/show-sick-leave`, {
        headers: headers
      }).then((response) => {
        if (response.data.status) {
          this.leaveData = response.data.data.leave_applications;
          this.annualLeaves = (response.data.data.yearly_leaves | 0);
          this.paidLeaves = response.data.data.paid_leaves;
          this.unpaidLeaves = response.data.data.unpaid_leaves;
          this.leaveData.forEach(element => {
            element["no_of_days"] = calcDays(element["start_date"], element["end_date"], element["half_no"]);
            element["start_date"] = formatMMNameYYYY(element["start_date"]);
            element["end_date"] = formatMMNameYYYY(element["end_date"]);
            element["status_updated_by"] = element["updated_by"] ? element["updated_by"]["first_name"] + ' ' + element["updated_by"]["last_name"] : '-';
            element["class"] = statusIconClass(element["status"]);
          });
        }
      }).catch(function (error) {
        console.log(error);
      }).finally(() => {
        this.loader = false
      });

    },

    async getMasterCategories() {
      await axios.get(`${VUE_APP_API_BASE_URL}/master-category`)
        .then((response) => {
          if (response.data.status) {
            this.masterCategoryIds = response.data.data;
            this.masterCategoryIds.forEach(element => {

              element['text'] = element['name'];
              delete element['name'];
            })
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        });
    },

    async onSickLeave() {
      let dateStringSingle = dayjs().format('YYYY-MM-DD');
      let start_date = dateStringSingle
      await axios.post(`${VUE_APP_API_BASE_URL}/leave/mark-sick-leave`, { user_id: this.id, start_date: start_date })
        .then((response) => {
          if (response.data.status) {
            this.$toast.success(response.data.message)
            this.checkForOnSickLeave()
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        });
    },

    async checkForOnSickLeave() {
      await axios.post(`${VUE_APP_API_BASE_URL}/leave/check-sick-leave`, { user_id: this.id })
        .then((response) => {
          if (response.data.status) {
            this.requiresFollowup = response.data.requires_followup;
            if (this.requiresFollowup) {
              this.onSickLeaveData = response.data.leave
            }
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        });
    },


    editClicked(record) {
      this.$refs.leaveAdmin.updateStatus(record);
    },

    getCategoriesName(id) {
      const name = this.masterCategoryIds.find(item => item.id === id);
      return name ? name.text : '-';
    },

    deleteClicked(id) {
      this.$refs.leaveAdmin.deleteLeave(id);
    },

    view(item, name) {
      this.$refs.sickLeave.updateValues(item, name);
    },

    // setAction() {
    //   this.accessToken = JSON.parse(localStorage.getItem("userInfo"));
    //   this.showActionButton = this.accessToken?.account_type === 'MEMBER' ? false : true;
    //   if (this.showActionButton) {
    //     if (!this.columns.some(column => column.title === "Action")) {
    //       this.columns.push({
    //         title: "Action",
    //         sorter: true,
    //         key: "action",
    //         text: "end",
    //       })
    //     }

    //   }
    // }

  },


}
</script>

<style scoped>
.pass-input.is-invalid+.toggle-password {
  bottom: 0;
}

.toggle-password {
  top: 49px !important;
  right: 28px;
  position: absolute;
}

.header-colour {
  background-color: #007bff;
  /* Example: a shade of blue */
}

.custom-modal .modal-content .modal-header {
  padding: 20px 30px 0;
}
</style>